import { type IntentDetectionSource } from '@atlassian/search-ai/query-intent-api/types';

import { type FireAnalyticsEvent } from '../../types';
import { getEnvironment } from '../get-environment';
import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

type commonAndPrivateAttributesType = {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	cloudId?: string;
};

export const onQueryIntentFailure = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	cloudId,
}: commonAndPrivateAttributesType): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: `smartAnswersQueryIntent`,
	action: 'failed',
	attributes: {
		commonAttributes,
		environment: getEnvironment(cloudId),
	},
	nonPrivacySafeAttributes,
});

export const onQueryIntentReturned = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	cloudId,
	queryIntentClassification,
	intentDetectionMethod,
	intentDetectionSource,
	intentDetectionBackendCacheHit,
}: commonAndPrivateAttributesType & {
	queryIntentClassification: string;
	/** Exact backend detection method (e.g. ENTITY_RECOGNITION); `UNKNOWN` when unavailable. */
	intentDetectionMethod: string;
	intentDetectionSource: IntentDetectionSource;
	/** Backend-reported cache flag; omitted when the backend did not report one. */
	intentDetectionBackendCacheHit?: boolean;
}): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: `smartAnswersQueryIntent`,
	action: 'returned',
	attributes: {
		commonAttributes,
		additionalAttributes: {
			environment: getEnvironment(cloudId),
			queryIntentClassification,
			intentDetectionMethod,
			intentDetectionSource,
			...(intentDetectionBackendCacheHit !== undefined && { intentDetectionBackendCacheHit }),
		},
	},
	nonPrivacySafeAttributes,
});

export const onQueryIntentFired = ({
	commonAttributes,
	nonPrivacySafeAttributes,
}: commonAndPrivateAttributesType): FireAnalyticsEvent => ({
	eventType: 'track',
	actionSubject: `smartAnswersQueryIntent`,
	action: 'fired',
	attributes: {
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
